/**
 * @description: DDOP事件统计，name找亮亮要
 * @param {string} name
 * @return {*}
 */
const DDOPTrackAction = async (name: string) => {
  const Sa = await import("@smm/sa")
  Sa.DefinedSa(
    "e",
    () => {
      // Note 埋点统计
    },
    10000,
    { name }
  )
}

/**
 * @description: DDOP 页面级统计
 * @return {*}
 */
const DDOPTrackPage = async () => {
  const Sa = await import("@smm/sa")
  Sa.DefaultSa.send_log_events()
}

export { DDOPTrackAction, DDOPTrackPage }
